// Should be rewritten to avoid global imports.
$ = window.$ = window.jQuery = require("jquery");
require("bootstrap");
require("jquery-ui/ui/widgets/tooltip");
$(document).ready(() => {
  $('.a-nav-list [data-toggle="collapse"].collapsed').on("click", () => {
    $("#overlay").addClass("show");
  });

  $('.a-nav-list [data-toggle="collapse"]:not(.collapsed), .a-close, #overlay').on("click", () => {
    $("#overlay").removeClass("show");
  });

  // Toggle menu button text between "Meny" and "Lukk"
  $("#m-main-nav").on("show.bs.collapse", function () {
    $("#nav-toggle-text").text("Lukk");
  });

  $("#m-main-nav").on("hide.bs.collapse", function () {
    $("#nav-toggle-text").text("Meny");
  });

  // Homepage mobile search: hide when menu opens, show when menu fully closes
  var $homeSearch = $("#intranet-home-mobile-search");
  if ($homeSearch.length) {
    $("#m-main-nav").on("show.bs.collapse", function () {
      $homeSearch.hide();
    });
    $("#m-main-nav").on("hide.bs.collapse", function () {
      $homeSearch.show();
    });
  }
});

require("./table");
require("./autocomplete");
require("./input-clear");
require("./emphasize-word");
require("./global-alert");
require("./intranet-service-status");
require("./what-we-do");
require("./intra-tabs");
require("./intranet-news-mentions");
require("./profile-file-upload");
require("./ie-warning.js");
require("./report-page.js");
require("./datepicker.js");
require("./fileUpload");
require("./form-file-upload");
